import styled, { css, keyframes } from 'styled-components'
import { colors, device } from '../../../styles/GlobalVariables'

interface StyledHeightPosterProps {
  display?: string
}

const loader = keyframes`
  0% {
    background-color: black;
  }
  100% {
    background-color: ${colors.tvGuideDark};
  }
`

export const RailItemWrap = styled.div`
  overflow: visible;
  cursor: pointer;
  color: white;
  height: 0;
  padding-bottom: calc(100% * 1.78);
  transition: all 0.2s ease;

  &.first {
    transform-origin: right;
  }

  &.last {
    transform-origin: left;
  }

  &:hover {
    transform: scale(1.05);
  }

  @media only screen and (max-width: 768px) {
    &:hover {
      transform: none;
    }
  }
`

export const RailItemImage = styled.img`
  border-radius: 0.5rem;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  transition: opacity 0.2s ease;

  ${props =>
    !props.theme.loaded &&
    css`
      animation: ${loader} 1s linear infinite;
    `}
  &:after {
    content: '';
    opacity: 0;
    transform-origin: center;
    position: absolute;
    bottom: 0.625rem;
    right: 0.625rem;
    width: 1.25rem;
    height: 1.25rem;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg fill='white' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2rem' height='2rem' viewBox='0 0 163.861 163.861' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275 c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z'/%3E%3C/g%3E%3C/svg%3E");
    z-index: 1;
  }

  ${device.small} {
    transition: transform 0.5s ease;
    &:hover {
      opacity: 1;

      &:after {
        opacity: 1;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`
export const RailItemProgramDetailsWrap = styled.div`
  position: absolute;
  cursor: pointer;
  margin-top: 10px;
`

export const RailItemName = styled.div<StyledHeightPosterProps>`
  color: #fff;
  text-align: right;
  width: 12vw;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 23px;
  font-weight: 400;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media only screen and (max-width: 768px) {
    width: 41vw;
    font-size: ${({ display }) =>
      display ? '' : '20px'}; // Keep font-size adjustment
  }
`
